/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Objective function enum
 */
export enum ObjectiveFunction {

    SharpeRatio = 'SharpeRatio',

    TotalReturn = 'TotalReturn',

    SortinoRatio = 'SortinoRatio',

    CalmarRatio = 'CalmarRatio',

    ProfitFactor = 'ProfitFactor',

    WinRate = 'WinRate',

    Custom = 'Custom'
}
